import PropTypes from 'prop-types';
import { TRAIN_LTS_PAGENAME } from '../pages/LiveTrainStatus/constants/LtsTrackingConstants';
import { trackClickEventProp61 } from './omnitureUtils';
import { LTS_LANDING_INSTRUMENTATION_PAGE_NAME } from '../pages/LTS/constants/SEOConstants';

export function getPageSectionName(pageName) {
  if (pageName === TRAIN_LTS_PAGENAME || LTS_LANDING_INSTRUMENTATION_PAGE_NAME || !pageName) {
    return '';
  }

  let pageSectionName = pageName.charAt(10);

  switch (pageSectionName) {
    case 't':
      pageSectionName = 'train';
      break;
    case 's':
      pageSectionName = 'station';
      break;
    case 'r':
      pageSectionName = 'route';
      break;
  }

  return pageSectionName;
}

export function getPageName(eventName) {
  if (!eventName) {
    return '';
  }

  let pageName = eventName.charAt(9);

  switch (pageName) {
    case 't':
      pageName = 'train';
      break;
    case 's':
      pageName = 'station';
      break;
    case 'r':
      pageName = 'route';
      break;
  }

  pageName = `seo:rails:${pageName}:index`;

  return pageName;
}

export function createTrackingCallback(pageName, trackingEventName) {
  const callback = () => {
    const pageSectionName = getPageSectionName(pageName);

    if (pageSectionName) {
      trackClickEventProp61(pageName, trackingEventName.replace('{{pageSectionName}}', pageSectionName));
    }
  };

  return callback;
}

getPageSectionName.PropTypes = {
  pageName: PropTypes.string.isRequired
};

getPageName.PropTypes = {
  eventName: PropTypes.string.isRequired
};
